import {client} from './services/client'

export  const roles = {
    namespaced:true,
    state:{
        roles:undefined,
    },
    mutations: {
        SET_ROLE (state,roles){
            state.roles = roles
        },

    },
    actions: {
        getrole({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/role/get',
                })
                    .then((response)=>{
                        let roles = response.data.roles;
                        console.log(roles);
                        commit('SET_ROLE',roles)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getnot({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/notrole/get/'+id,
                })
                    .then((response)=>{
                        let roles = response.data.roles;
                        console.log(roles);
                        commit('SET_ROLE',roles)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setrole({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/role/save',
                    data:data,
                })
                    .then((response)=>{
                        let roles = response.data.roles;
                        commit('SET_ROLE',roles);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleterole({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/role/delete/'+id,
                })
                    .then((response)=>{
                        let roles = response.data.roles;
                        commit('SET_ROLE',roles);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getrole: state  => {
            return state.roles
        },
    }
};
